<template>
  <!-- 웹 버전 점검 화면: 닫기 수단 없이 화면 전체를 덮는다 -->
  <div class="webmaintenance noselect" @contextmenu.prevent>
    <div class="wm-stage">
      <div class="wm-card">
        <svg class="wm-icon" viewBox="0 0 48 44" aria-hidden="true">
          <path
            d="M20.5 3.5a4 4 0 0 1 7 0l19 33a4 4 0 0 1-3.5 6h-38a4 4 0 0 1-3.5-6z"
            fill="#0a86ff"
          />
          <rect x="21.5" y="12" width="5" height="16" rx="2.5" fill="#fff" />
          <circle cx="24" cy="34" r="3" fill="#fff" />
        </svg>
        <img class="wm-char" src="../assets/booksMaintenanceChar.png" alt="" />
        <p class="wm-title">{{ text.title }}</p>
        <div class="wm-box">
          <p>
            {{ text.line1 }}<br />
            {{ text.line2 }}
          </p>
          <p>
            {{ text.line3Before }}<span class="wm-yellow">{{
              text.line3Highlight
            }}</span
            >{{ text.line3After }}<br />
            {{ text.line4 }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const TEXT = {
  ko: {
    title: "웹 버전 점검 안내",
    line1: "지금은 웹 버전 이용이 어려운 상황이에요.",
    line2: "불편을 드려 죄송합니다.",
    line3Before: "스토어에서 ",
    line3Highlight: "'메타 라이브러리'를 검색해 앱으로 이용",
    line3After: "해 주세요.",
    line4: "웹은 원인을 확인 중이며, 정상화되면 바로 알려드릴게요.",
  },
  en: {
    title: "Web Is Under Maintenance",
    line1: "The web version is currently hard to access,",
    line2: "and we're sorry for the trouble.",
    line3Before: "Please ",
    line3Highlight: 'download the "Meta Library" app',
    line3After: " from the app store in the meantime.",
    line4:
      "We're looking into the web issue and will let you know once it's back.",
  },
};

export default {
  name: "WebMaintenanceModal",
  computed: {
    text() {
      return this.$store.state.lang === "ko" ? TEXT.ko : TEXT.en;
    },
  },
};
</script>

<style scoped>
/* 1920x1080 디자인 기준, 화면 비율에 맞춰 축소/확대 */
.webmaintenance {
  --u: calc(min(100vw, 177.7778vh) / 1920);
  position: fixed;
  inset: 0;
  z-index: 999999999;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.wm-stage {
  position: relative;
  width: calc(1920 * var(--u));
  height: calc(1080 * var(--u));
}

.wm-card {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1.15);
  width: calc(1592 * var(--u));
  height: calc(796 * var(--u));
  background: rgb(128, 216, 254);
  border-radius: calc(68 * var(--u));
  overflow: hidden;
}

.wm-icon {
  position: absolute;
  left: calc(36 * var(--u));
  top: calc(36 * var(--u));
  width: calc(48 * var(--u));
}

.wm-char {
  position: absolute;
  left: calc(170 * var(--u));
  top: calc(170 * var(--u));
  width: calc(448 * var(--u));
}

.wm-title {
  position: absolute;
  left: 0;
  top: calc(30 * var(--u));
  width: 100%;
  margin: 0;
  text-align: center;
  font-family: cookiebold;
  font-size: calc(64 * var(--u));
  color: #ffffff;
  -webkit-text-stroke: calc(10 * var(--u)) #0a5fc4;
  paint-order: stroke fill;
  text-shadow: 0 calc(6 * var(--u)) 0 #0a5fc4;
}

.wm-box {
  position: absolute;
  left: calc(641 * var(--u));
  top: calc(197 * var(--u));
  width: calc(877 * var(--u));
  height: calc(419 * var(--u));
  box-sizing: border-box;
  padding: 0 calc(36 * var(--u));
  background: #006dd3;
  border-radius: calc(28 * var(--u));
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: calc(46 * var(--u));
  color: #ffffff;
  font-family: cookieregular, notosansmedium;
  font-size: calc(32 * var(--u));
  line-height: 1.5;
}

.wm-box p {
  margin: 0;
}

.wm-yellow {
  color: #ffd52e;
  text-decoration: underline;
  text-underline-offset: calc(6 * var(--u));
}
</style>
